import { render, staticRenderFns } from "./EnvForm.vue?vue&type=template&id=db21cb1e&scoped=true"
import script from "./EnvForm.vue?vue&type=script&lang=js"
export * from "./EnvForm.vue?vue&type=script&lang=js"
import style0 from "./EnvForm.vue?vue&type=style&index=0&id=db21cb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db21cb1e",
  null
  
)

export default component.exports